import { Breadcrumbs, Link, Stack, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import Toolbar from "./Toolbar/Toolbar";
import AdsStats from "./Stats/AdsStats";
import AdsTable from "./Table/AdsTable";
import { useNavigate } from "react-router-dom";
import { useBoundStore } from "useStore";
import { useShallow } from "zustand/react/shallow";

export default function AdsPage({ paginatedAds, filteredAds }) {
  const navigate = useNavigate();
  const { clearSelectedCampaign } = useBoundStore(
    useShallow((state) => ({
      clearSelectedCampaign: state.clearSelectedCampaign,
    })),
  );

  const handleBackToCampaigns = () => {
    clearSelectedCampaign();
    navigate("/martech/campaign-manager");
  };
  return (
    <Stack gap={2}>
      <Stack direction="row" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
            <Stack direction="row" alignItems="center" spacing={0.5}>
              <LayersOutlinedIcon
                sx={{
                  width: "24px",
                  height: "24px",
                  fill: "#00000099",
                }}
              />
              <Link
                component="button"
                underline="hover"
                onClick={handleBackToCampaigns}
                sx={{
                  fontSize: "14px",
                  color: "#00000099",
                  cursor: "pointer",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 400,
                    fontSize: "16px",
                    color: "#00000099",
                    lineHeight: "24px",
                  }}
                >
                  Campañas
                </Typography>
              </Link>
            </Stack>
            <Typography
              sx={{
                fontSize: "16px",
                color: "#000000DE",
                fontWeight: 400,
              }}
            >
              Anuncios
            </Typography>
          </Breadcrumbs>
        </Stack>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 400,
            fontSize: "12px",
            color: "#00000099",
            lineHeight: "24px",
          }}
        >
          Last update: 24/02/2026 16:26:00
        </Typography>
      </Stack>
      <Toolbar />
      <AdsStats />

      <AdsTable data={paginatedAds} rowCount={filteredAds.length} />
    </Stack>
  );
}
